
declare interface Date 
{
    setApiCompatible: () => void;
}

(function()
{
    function pad(number) 
    {
        if (number < 10) 
        {
            return '0' + number;
        }

        return number;
    }


    if (Date.prototype['setApiCompatible'] == null)
    {
        Object.defineProperty(Date.prototype, 'setApiCompatible', {
            value: function() {
                this.serializeLocalTime = true;
            }
        });

        Object.defineProperty(Date.prototype, 'toJSON', {
            value: function() {
                if(this.serializeLocalTime)
                {
                    return `${this.getFullYear()}-${pad(this.getMonth() + 1)}-${pad(this.getDate())}T${pad(this.getHours())}:${pad(this.getMinutes())}:${pad(this.getSeconds())}.${(this.getMilliseconds() / 1000).toFixed(3).slice(2, 5)}`                  
                }

                return this.toISOString();
            }
        });
    }
})();
